// Shared delivery zone definitions used by the map page and the quote modal.
// All polygon coordinates are [lat, lng] pairs.

// Approximate center of Zone 1 — used as the radar/dispatch origin
export const DELIVERY_CENTER: [number, number] = [47.37, -122.08]

export type DeliveryZone = {
  id: number
  price: string
  fee: number
  color: string
  polygons: number[][][]
}

export const DELIVERY_ZONES: DeliveryZone[] = [
  {
    id: 1,
    price: '+$40',
    fee: 40,
    color: '#b8b55c',
    polygons: [
      [
        [47.4800228, -122.1766336],
        [47.4781524, -122.0089267],
        [47.3890443, -122.0078198],
        [47.367306, -121.9823593],
        [47.2562263, -121.9790384],
        [47.2577289, -122.0786662],
        [47.3001607, -122.0803267],
        [47.2997853, -122.1766336],
      ],
    ],
  },
  {
    id: 2,
    price: '+$75',
    fee: 75,
    color: '#e18251',
    polygons: [
      [
        [47.493847, -122.2378074],
        [47.4079115, -122.2366727],
        [47.3871739, -122.2661738],
        [47.2895208, -122.2707125],
        [47.2579565, -122.2724145],
        [47.2564163, -122.2309994],
        [47.254876, -122.1589485],
        [47.2202085, -122.1209375],
        [47.1905306, -122.0812244],
        [47.1932292, -121.9246414],
        [47.3214509, -121.8803897],
        [47.3833327, -121.8565619],
        [47.4923136, -121.9030829],
        [47.5428899, -121.9921537],
        [47.5444218, -122.2014983],
        [47.5156921, -122.2151142],
      ],
    ],
  },
  {
    id: 3,
    price: '+$120',
    fee: 120,
    color: '#ba8989',
    polygons: [
      [
        [47.4797527, -122.3799196],
        [47.4868588, -122.2845333],
        [47.5386029, -122.2469796],
        [47.5654694, -122.2394689],
        [47.5786441, -122.2627521],
        [47.5989065, -122.2635032],
        [47.6009323, -122.2109281],
        [47.6090347, -122.2191899],
        [47.6237172, -122.2529882],
        [47.6247296, -122.0824945],
        [47.58675, -122.1027735],
        [47.5715504, -122.0802413],
        [47.5680032, -122.0697262],
        [47.5659762, -121.9841039],
        [47.5604013, -121.9210137],
        [47.5872566, -121.8767004],
        [47.5380958, -121.7955844],
        [47.5167954, -121.7963355],
        [47.489904, -121.7565286],
        [47.4005053, -121.7948333],
        [47.1262874, -121.7828162],
        [47.135485, -122.1703701],
        [47.1375287, -122.3220869],
        [47.2125795, -122.3258423],
        [47.2814104, -122.4317437],
        [47.3124824, -122.4565291],
        [47.3440451, -122.3881814],
        [47.3862688, -122.3543831],
        [47.4208365, -122.3648981],
        [47.4533502, -122.3919368],
        [47.4787375, -122.3814217],
        [47.4802603, -122.3791685],
      ],
    ],
  },
  {
    id: 4,
    price: '+$150',
    fee: 150,
    color: '#c98ea3',
    polygons: [
      [
        [47.4811923, -122.3817267],
        [47.4882313, -122.2885317],
        [47.4908243, -122.2852425],
        [47.5363671, -122.2507055],
        [47.5633779, -122.2419342],
        [47.5781724, -122.2666035],
        [47.6003563, -122.2660553],
        [47.6014653, -122.2644107],
        [47.6025742, -122.2167168],
        [47.6066401, -122.2216506],
        [47.6247478, -122.2578322],
        [47.6262257, -122.0758279],
        [47.5874168, -122.0999489],
        [47.5696661, -122.0725386],
        [47.5681865, -121.990856],
        [47.562638, -121.9245231],
        [47.5903747, -121.8746364],
        [47.6698051, -121.8784738],
        [47.6919796, -121.8847425],
        [47.6908566, -122.2275923],
        [47.648164, -122.2609597],
        [47.6532215, -122.4311333],
        [47.5176231, -122.4152838],
        [47.4815546, -122.3810822],
      ],
      [
        [47.1378994, -122.3253043],
        [47.2116354, -122.3283859],
        [47.28067, -122.4337773],
        [47.3763375, -122.596092],
        [47.3711888, -122.6470301],
        [47.2959613, -122.7131736],
        [47.2102985, -122.6204206],
        [47.1374278, -122.503339],
        [47.137945, -122.3246755],
      ],
    ],
  },
  {
    id: 5,
    price: '+$180',
    fee: 180,
    color: '#804747',
    polygons: [
      [
        [47.6565115, -122.4327801],
        [47.653895, -122.4277859],
        [47.6494092, -122.26353],
        [47.6927554, -122.2280152],
        [47.6935337, -121.8830617],
        [47.8649522, -121.8961914],
        [47.8630646, -122.3538557],
        [47.7982166, -122.4176286],
        [47.6637939, -122.435168],
        [47.6563998, -122.432689],
      ],
      [
        [47.1875694, -122.5900098],
        [47.1338075, -122.5002979],
        [47.1358763, -122.3254358],
        [47.1296697, -122.0365331],
        [47.0727425, -122.0357728],
        [47.0742959, -122.1688201],
        [46.8449449, -122.1703407],
        [46.8511846, -122.4805309],
        [47.0204194, -122.4774898],
        [47.0188644, -122.6044549],
        [47.1265662, -122.6629958],
      ],
    ],
  },
]

// Ray-casting point-in-polygon test
export function isPointInPolygon(
  lat: number,
  lng: number,
  polygon: number[][],
): boolean {
  let inside = false
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0]
    const yi = polygon[i][1]
    const xj = polygon[j][0]
    const yj = polygon[j][1]
    const intersect =
      yi > lng !== yj > lng && lat < ((xj - xi) * (lng - yi)) / (yj - yi) + xi
    if (intersect) inside = !inside
  }
  return inside
}

export function getZoneForPosition(
  lat: number,
  lon: number,
): { zone: number; price: string; fee: number; color: string } {
  for (const zone of DELIVERY_ZONES) {
    for (const polygon of zone.polygons) {
      if (isPointInPolygon(lat, lon, polygon)) {
        return {
          zone: zone.id,
          price: zone.price,
          fee: zone.fee,
          color: zone.color,
        }
      }
    }
  }
  return { zone: 0, price: 'Custom', fee: 0, color: '#e8d49e' }
}
